import _ from 'lodash';
import { scroller } from 'react-scroll';
import { isEmpty } from './common';
import { toDotArray } from './common/ArrayHelper';
import { scrollToWithHeaderHeight } from './ScrollUtils';
export const getFormValue = (form, name) => _.get(form, `values.${name}`) || null;
/**
 * form内の指定の項目のエラーを取得する
 * @param form
 * @param name
 * @param checkIsTouch
 * @returns {null}
 */
export const getFormError = (form, name, checkIsTouch = true) => {
    const errors = form.syncErrors || {};
    const fields = form.fields || {};
    const field = _.get(fields, name) || {};
    const error = _.get(errors, name);
    if (checkIsTouch) {
        return !!field.touched && error ? error : null;
    }
    return error || null;
};
/**
 * form内の指定の項目のエラーを複数取得する
 * @param form
 * @param names
 * @param checkIsTouch
 * @returns {Array}
 */
export const getFormErrors = (form, names, checkIsTouch = true) => {
    const results = [];
    (names || []).forEach((name) => {
        const error = getFormError(form, name, checkIsTouch);
        if (error) {
            results.push(error);
        }
    });
    return results;
};
/**
 * form内の指定の項目のエラーから最初の1件を種痘する
 * @param form
 * @param names
 * @param checkIsTouch
 * @returns {null}
 */
export const getFormErrorsFirst = (form, names, checkIsTouch = true) => {
    const results = getFormErrors(form, names, checkIsTouch);
    return results.length > 0 ? results[0] : null;
};
/**
 * form内の指定の表示中のエラーを取得する
 * @param form
 * @param name
 * @returns {null}
 */
export const getFormShowError = (form, name) => {
    const errors = getFormErrors(form, [name]);
    return _.first(errors);
};
/**
 * form内の指定の表示中のエラーを取得する
 * @param form
 * @returns {Array}
 */
export const getFormShowErrors = (form) => getFormErrors(form, Object.keys((form || {}).registeredFields || {}));
/**
 * formが指定の項目を全て持っているかどうか
 * @param form
 * @param names
 * @returns {boolean}
 */
export const isFieldsHasValue = (form, names) => {
    const values = form.values || {};
    const emptyValue = names.find((name) => isEmpty(values[name]));
    return !emptyValue;
};
/**
 * フォームが指定の項目の一覧にエラーがあるか、指定の項目の一覧を全て所持しているかを判定する
 * @param form
 * @param names
 * @param requires
 * @returns {boolean}
 */
export const isCleanFields = (form, names, requires) => !!(getFormErrors(form, names, false).length === 0 &&
    isFieldsHasValue(form, requires));
/**
 * submitボタンを押下した際の入力チェック＋エラー時の該当項目までの画面スクロールの実行
 * @param e
 * @param syncErrorKeys
 * @return {boolean}
 */
export const onClickSubmitCheckForSyncErrors = (e, syncErrorKeys) => {
    let isInModal = false;
    let findElement = e.currentTarget;
    while (!isInModal && findElement) {
        const hasModal = findElement.className.indexOf('modal') >= 0;
        const hasActive = findElement.className.indexOf('is-active') >= 0;
        if (hasModal && hasActive) {
            isInModal = true;
        }
        else {
            findElement = findElement.parentElement || null;
        }
    }
    if (syncErrorKeys.length > 0) {
        let syncErrorKey = _.first(syncErrorKeys)
            .replace(/\.([\d]+)/g, '[$1]')
            .replace(/\[_error]/g, '');
        const syncErrorKeyView = `${syncErrorKey}_view`;
        const findViewQuerySelector = `[name="${syncErrorKeyView.replace(/([[\]])/g, '\\$1')}"]`;
        const errorViewElement = document.querySelector(findViewQuerySelector);
        if (errorViewElement) {
            syncErrorKey = syncErrorKeyView;
        }
        if (!isInModal) {
            scroller.scrollTo(syncErrorKey, {
                offset: -150,
                smooth: true,
            });
        }
        return false;
    }
    return true;
};
/**
 * submitボタンを押下した際の入力チェック＋エラー時の該当項目までの画面スクロールの実行
 * @param thisForm
 * @returns {function(*): boolean}
 */
export const onClickSubmitCheck = (thisForm) => (e) => {
    const dotObjects = toDotArray(thisForm.syncErrors || {});
    const syncErrors = Object.keys(dotObjects).filter((v) => dotObjects[v]);
    return onClickSubmitCheckForSyncErrors(e, syncErrors);
};
/**
 * formでのsubmitがvalidation errorで失敗した場合の画面スクロールの実行
 * @param name
 * @param args
 */
export const formValidateScroll = (name, args = {}) => {
    const viewName = `${name}_view`;
    const viewElement = document.getElementsByName(viewName)[0];
    if (viewElement) {
        scrollToWithHeaderHeight(viewName, args);
        return;
    }
    scrollToWithHeaderHeight(name, args);
};
/**
 * Final Formのエラーオブジェクトに応じた要素にスクロールする
 * @param errors
 * @param args
 */
export const finalFormValidateScroll = (errors, args) => {
    const dots = Object.keys(toDotArray(errors || {}, '', {}, true));
    if (dots.length) {
        formValidateScroll(dots[0], args || { offset: -(window.innerHeight * 0.5) });
    }
};
